import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorQueryKey } from '@/modules/operator/keys'
import {
	GetUploadFileUrlResponse,
	GetUploadlFileUrlRequest,
} from '@/modules/operator/type'
import { getLuckyWheelImageUploadFileUrl } from '../../services'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreateLuckyWheelImageFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [OperatorQueryKey.GetUploadLuckyWheelImageFileUrl],
		mutationFn: (params) => getLuckyWheelImageUploadFileUrl(params.payload),
		...props,
	})
}
